export function checkDisabledSp(slug,products, spUserOverride=false) {
    products = products.filter((product) => {
        return product.sp_slug === slug;
    });

    if(products.length === 0) {
        return true;
    }

    /* SP USER OVERRIDE CHECKED */
    let isSpOverride = false;
    if (spUserOverride && spUserOverride.length > 0) {
        const foundProduct = spUserOverride.find((userSp) => products[0].id == userSp.uspa_sp_id);
        if (foundProduct && foundProduct.uspa_sp_enabled === '1') {
            isSpOverride = true;
        }
    }
    
    let disabledRoles = products[0].sp_disabled_roles;
    if(disabledRoles) {

        if(slug === 'eportfolio'){
            // Apprentice Role Id: 66f53056302e75028e34e173
            if(disabledRoles.split(',').includes('66f53056302e75028e34e173')) {
                if (isSpOverride) {
                    return false;
                }
                return true;
            }
        } else {
            if(disabledRoles.split(',').includes('2')){
                if (isSpOverride) {
                    return false;
                }
                return true;
            }
        }

    }
    return false;
}